// An incomplete mapping of what we respond with from SchoolDetailsController.java. (I'm just covering the parts this
// component needs for now.)
interface SchoolDetailsResult {
    name: string,
    cityAndState: string,
}

// Must be a subset of SchoolSearchDetails.propTypes.
interface SearchResultProps {
    schoolDetails: SchoolDetailsResult,
    clearSelectedSchool: () => {},
}

/**
 * A stripped-down version of what's in SchoolSearchDetails intended for use in the iHeartRadio sweepstakes form.
 */
export const SearchResult = ({schoolDetails, clearSelectedSchool}: SearchResultProps) => {
    return (
            <div className="search-result">
                School of nominated teacher:
                <strong className="school">{schoolDetails.name}</strong>
                <div className="location">{schoolDetails.cityAndState}</div>
                <div className="inline-button">
                    <button className="text-link small" onClick={clearSelectedSchool}>Change school</button>
                </div>
            </div>
    );
}
